import React, { useState, useEffect, useRef } from 'react';

import { useNavigate } from "react-router-dom";
import PaymentGateway from '../PaymentGateway';
import { Upload, Building2, Phone, MapPin, Info, Image as ImageIcon, Share2, AlertCircle } from 'lucide-react';




  const InputField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  type = "text",
  placeholder,
  required = false,
  maxLength,
  rows,
  error,
  touched,
}) => {
  const isTextarea = !!rows;
  const Component = isTextarea ? "textarea" : "input";

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-800 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <Component
        type={type}
        name={name}
        value={value}              
        onChange={onChange}       
        onBlur={onBlur}            
        placeholder={placeholder}
        maxLength={maxLength}
        rows={rows}
        className={`w-full px-4 py-3 bg-gray-50 border rounded-xl focus:outline-none focus:ring-2 transition-all ${
          error && touched
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-200 focus:ring-orange-500 focus:border-transparent"
        }`}
      />

      {error && touched && (
        <div className="flex items-center gap-1 mt-1 text-red-600 text-sm">
          <AlertCircle className="w-4 h-4" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

const TempleRegistration = () => {
  const navigate = useNavigate();
  const [showPayment, setShowPayment] = useState(false);
  const TEMPLE_PROFILE_KEY = "temple_profile";
  const hasCheckedProfile = useRef(false);



  const [formData, setFormData] = useState({
    templeName : '',
    mainDeity  : '',
    otherDeities:'',
    establishedYear: '',
    eventsCalendar:[],
    contactPerson: '',
    mobileNumbers: '',
    email: '',
   address: '',
    city: '',
    state: '',
    pincode: '',
    googleMapLink : '',
    description: '',
    darshanTimings: '',
   specialSevas: '',
    templeRules: '',
    instagramLink: '',
    whatsappLink : '',
    youtubeLink: '',
     profileImage: null,
    galleryImages: []
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [profilePreview, setProfilePreview] = useState(null);
  const [galleryPreviews, setGalleryPreviews] = useState([]);

 useEffect(() => {
  if (hasCheckedProfile.current) return;

  hasCheckedProfile.current = true;

  const existingProfile = localStorage.getItem(TEMPLE_PROFILE_KEY);

  if (existingProfile) {
    console.warn("🚫 Profile already exists. Redirecting...");
    navigate("/temple-dashboard");
  }
}, [navigate]);


  
  // Validation rules
  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'templeName ':
        if (!value.trim()) {
          error = 'Temple name is required';
        } else if (value.trim().length < 3) {
          error = 'Temple name must be at least 3 characters';
        }
        break;

      case 'mainDeity  ':
        if (!value.trim()) {
          error = 'Main Divine name is required';
        } else if (value.trim().length < 2) {
          error = 'Divine name must be at least 2 characters';
        }
        break;

      case 'establishedYear':
        if (!value) {
          error = 'Year established is required';
        } else if (!/^\d{4}$/.test(value)) {
          error = 'Please enter a valid 4-digit year';
        } else {
          const year = parseInt(value);
          const currentYear = new Date().getFullYear();
          if (year < 1000 || year > currentYear) {
            error = `Year must be between 1000 and ${currentYear}`;
          }
        }
        break;

      case 'contactPerson':
        if (!value.trim()) {
          error = 'Contact person name is required';
        } else if (value.trim().length < 3) {
          error = 'Name must be at least 3 characters';
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          error = 'Name should only contain letters';
        }
        break;

        case 'specialSevas':
  if (!value.trim()) {
    error = 'Please enter special sevas or pujas';
  }
  break;


      case 'mobileNumbers':
        if (!value) {
          error = 'Mobile number is required';
        } else if (!/^[6-9]\d{9}$/.test(value)) {
          error = 'Please enter a valid 10-digit Indian mobile number';
        }
        break;

      case 'email':
        if (!value) {
          error = 'Email address is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'Please enter a valid email address';
        }
        break;

      case 'fullAddress':
        if (!value.trim()) {
          error = 'Full address is required';
        } else if (value.trim().length < 10) {
          error = 'Please enter a complete address (at least 10 characters)';
        }
        break;

      case 'city':
        if (!value.trim()) {
          error = 'City is required';
        } else if (value.trim().length < 2) {
          error = 'City name must be at least 2 characters';
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          error = 'City name should only contain letters';
        }
        break;

      case 'state':
        if (!value.trim()) {
          error = 'State is required';
        } else if (value.trim().length < 2) {
          error = 'State name must be at least 2 characters';
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          error = 'State name should only contain letters';
        }
        break;

      case 'pincode':
        if (!value) {
          error = 'Pincode is required';
        } else if (!/^\d{6}$/.test(value)) {
          error = 'Please enter a valid 6-digit pincode';
        }
        break;

      case 'googleMapLink ':
        if (value && !/^(https?:\/\/)|([-+]?\d+\.\d+,\s*[-+]?\d+\.\d+)/.test(value)) {
          error = 'Please enter a valid URL or coordinates (lat,lng)';
        }
        break;

      case 'description':
        if (!value.trim()) {
          error = 'Temple description is required';
        } else if (value.trim().length < 50) {
          error = 'Description must be at least 50 characters';
        }
        break;

      case 'darshanTimings':
        if (!value.trim()) {
          error = 'Darshan timings are required';
        } else if (value.trim().length < 10) {
          error = 'Please provide detailed timing information';
        }
        break;

      case 'instagramLink':
        if (value && !/^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._]+\/?$/.test(value)) {
          error = 'Please enter a valid Instagram profile URL';
        }
        break;

      case 'whatsappLink ':
        if (value && !/^https?:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?$/.test(value)) {
          error = 'Please enter a valid Facebook page URL';
        }
        break;

      case 'youtubeLink':
        if (value && !/^https?:\/\/(www\.)?(youtube\.com\/(channel\/|c\/|user\/|@)|youtu\.be\/)[a-zA-Z0-9_-]+\/?$/.test(value)) {
          error = 'Please enter a valid YouTube channel URL';
        }
        break;

      default:
        break;
    }

    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Real-time validation
    if (touched[name]) {
      const error = validateField(name, value);
      setErrors(prev => ({
        ...prev,
        [name]: error
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    
    setTouched(prev => ({
      ...prev,
      [name]: true
    }));

    const error = validateField(name, value);
    setErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

 
const handlePaymentClose = () => {
  setShowPayment(false);
};


const handleprofileImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setErrors(prev => ({
          ...prev,
            profileImage: 'Image size must be less than 5MB'
        }));
        return;
      }
      
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        setErrors(prev => ({
          ...prev,
            profileImage: 'Only JPG and PNG images are allowed'
        }));
        return;
      }

      setFormData(prev => ({ ...prev,   profileImage: file }));
      setErrors(prev => ({ ...prev,   profileImage: '' }));
      
      const reader = new FileReader();
      reader.onloadend = () => setProfilePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handlegalleryImagesUpload = (e) => {
    const files = Array.from(e.target.files).slice(0, 10);
    const validFiles = [];
    let errorMessage = '';

    files.forEach(file => {
      if (file.size > 5 * 1024 * 1024) {
        errorMessage = 'Some files exceed 5MB and were skipped';
      } else if (!['image/jpeg', 'image/png'].includes(file.type)) {
        errorMessage = 'Only JPG and PNG images are allowed';
      } else {
        validFiles.push(file);
      }
    });

    if (errorMessage) {
      setErrors(prev => ({ ...prev, galleryImages: errorMessage }));
    } else {
      setErrors(prev => ({ ...prev, galleryImages: '' }));
    }

    setFormData(prev => ({ ...prev, galleryImages: validFiles }));
    
    const previews = [];
    validFiles.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        previews.push(reader.result);
        if (previews.length === validFiles.length) {
          setGalleryPreviews(previews);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      'templeName ', 'mainDeity  ','specialSevas', 'establishedYear', 'contactPerson',
      'mobileNumbers', 'email', 'fullAddress', 'city', 'state',
      'pincode', 'description', 'darshanTimings'
    ];

    requiredFields.forEach(field => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    // Validate optional fields if they have values
    ['googleMapLink ', 'instagramLink', 'whatsappLink ', 'youtubeLink'].forEach(field => {
      if (formData[field]) {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
        }
      }
    });

   if (formData.eventsCalendar.length === 0) {
  newErrors.eventsCalendar = 'Annual Pooja & Festival Calendar is required';
}



    if (!formData.  profileImage) {
      newErrors.  profileImage = 'Temple profile image is required';
    }

    setErrors(newErrors);
    setTouched(
      requiredFields.reduce((acc, field) => ({ ...acc, [field]: true }), {})
    );

    return Object.keys(newErrors).length === 0;
  };

  const handleCreateProfile = () => {
  if (!validateForm()) {
    alert('Please fix all errors before submitting the form');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  
  setShowPayment(true);
};


const handlePaymentSuccess = () => {
  const existingProfile = localStorage.getItem(TEMPLE_PROFILE_KEY);

  if (existingProfile) {
    alert("Temple profile already exists. You can only update it.");
    navigate("/temple-dashboard");
    return;
  }

  const templeProfile = {
    id: Date.now(),
    templeName : formData.templeName ,
    mainDeity  : formData.mainDeity  ,
    otherDeities:formData.otherDeities,
    establishedYear: formData.establishedYear,
    eventsCalendar:formData.eventsCalendar,
    contactPerson: formData.contactPerson,
    mobileNumbers: formData.mobileNumbers,
    email: formData.email,
   address: formData.fullAddress,
    city: formData.city,
    state: formData.state,
    pincode: formData.pincode,
    googleMapLink : formData.googleMapLink ,
    description: formData.description,
    darshanTimings: formData.darshanTimings,
   specialSevas: formData.specialSevas,
    templeRules: formData.templeRules,
    createdAt: new Date().toISOString(),
  };

  console.log("💾 Temple profile created:", templeProfile);

  localStorage.setItem(
    TEMPLE_PROFILE_KEY,
    JSON.stringify(templeProfile)
  );

  alert("✅ Temple profile created successfully!");
  navigate("/temple-dashboard");
};



    if (showPayment) {
    return (
      <PaymentGateway
        amount="1999"
        userDetails={{
          name: formData.contactPerson,
          email: formData.email,
          phone: formData.mobileNumbers,
        }}
        paymentType="temple_profile_creation"
        metadata={{
          templeData: formData,
        }}
        
        // 🔥 When you have the API ready, integrate it here
        onPaymentSubmit={async (paymentData) => {
          try {
            // TODO: Replace this with actual API call when ready
            /*
            await templeSubscriptionYearly({
              paymentId: paymentData.paymentId,
              orderId: paymentData.orderId,
              amount: paymentData.amount,
              subscriptionType: "YEARLY",
            });
            */
            
            console.log('Temple Payment Submitted:', paymentData);
            console.log('Temple Subscription would be activated here');
          } catch (err) {
            console.error('Temple subscription activation failed:', err);
            throw err; // ⛔ stops onSuccess
          }
        }}

        // ✅ Runs ONLY if payment + API succeed
        onSuccess={handlePaymentSuccess}
        
        onClose={handlePaymentClose}
        title="Complete Temple Profile Creation"
        description="One-time payment to activate your temple profile"
      />
    );
  }

 const handleFileChange = (e) => {
  const files = Array.from(e.target.files);

  if (files.length > 2) {
    setErrors((prev) => ({
      ...prev,
      eventsCalendar: "You can upload a maximum of 2 files only.",
    }));
    e.target.value = ""; // reset input
    return;
  }

  setErrors((prev) => ({
    ...prev,
    eventsCalendar: "",
  }));
setTouched(prev => ({
  ...prev,
  eventsCalendar: true,
}));

  const uniqueFiles = files.filter(
  file => !formData.eventsCalendar.some(f => f.name === file.name)
);

setFormData(prev => ({
  ...prev,
  eventsCalendar: uniqueFiles,
}));
};

const removeFile = (index) => {
  setFormData((prev) => ({
    ...prev,
    eventsCalendar: prev.eventsCalendar.filter(
      (_, i) => i !== index
    ),
  }));
};





   


  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50 py-8 px-4 mt-16">
       <div className='bg-white max-w-6xl mx-auto border border-orange-300 rounded-3xl' >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full mb-6 mt-4 shadow-lg">
            <Building2 className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-red-600 mb-3">
            Create Temple Profile
          </h1>
          <p className="text-gray-600 text-lg">
            Complete your temple's profile to get started with our services
          </p>
        </div>

        {/* Basic Details Section */}
        <div className="bg-white rounded-2xl  mb-8 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-600 via-red-500 to-orange-600 px-1 py-1  border-b border-orange-200">
            <div className="flex items-center gap-4">
              <Building2 className="w-4 h-4 ml-2 text-white" />
              <div className="flex items-center gap-2">
  <h2 className="text-sm font-bold text-white">Basic Details</h2>
  <span className="text-white">•</span>
  <p className="text-sm text-white">
    Essential information about your temple
  </p>
</div>

            </div>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
             <InputField
  label="Temple Name"
  name="templeName "
  value={formData.templeName }
  onChange={handleInputChange}
  onBlur={handleBlur}
  placeholder="Enter temple name"
  required
  error={errors.templeName }
  touched={touched.templeName }
/>

              <InputField
                label="Main Divine Name"
                name="mainDeity  "
                value={formData.mainDeity  }
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.mainDeity  }
                touched={touched.mainDeity  }
                placeholder="Enter main Divine name"
                required
              />
              <InputField
                label="Year Established"
                name="establishedYear"
                value={formData.establishedYear}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.establishedYear}
                touched={touched.establishedYear}
                placeholder="YYYY"
                maxLength="4"
                required
              />
               <InputField
                label="other Divine Name"
                name="otherDeities"
                value={formData.otherDeities}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.otherDeities}
                touched={touched.otherDeities}
                placeholder="Enter other Divine name"
                required={false}
              />
            </div>
          </div>
        </div>

        {/* Contact Information Section */}
        <div className="bg-white rounded-2xl  mb-8 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-600 via-red-500 to-orange-600 px-1 py-1 border-b border-orange-200">
            <div className="flex items-center gap-4">
              <Phone className="w-4 h-4 ml-2 text-white" />
              <div className='flex items-center gap-2'>
                <h2 className="text-sm font-bold text-white">Contact Information</h2>
                <span className="text-white">•</span>
                <p className="text-sm text-white mt-1">How can people reach your temple</p>
              </div>
            </div>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <InputField
                label="Contact Person Name"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.contactPerson}
                touched={touched.contactPerson}
                placeholder="Enter contact person name"
                required
              />
              <InputField
                label="Mobile Number"
                name="mobileNumbers"
                type="tel"
                value={formData.mobileNumbers}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.mobileNumbers}
                touched={touched.mobileNumbers}
                placeholder="10-digit mobile number"
                maxLength="10"
                required
              />
              <InputField
                label="Email Address"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.email}
                touched={touched.email}
                placeholder="temple@example.com"
                required
              />
            </div>
          </div>
        </div>

        {/* Location Details Section */}
        <div className="bg-white rounded-2xl  mb-8 overflow-hidden">
          <div className="bg-gradient-to-r  from-orange-600 via-red-500 to-orange-600 px-1 py-1 border-b border-orange-200">
            <div className="flex items-center gap-3">
              <MapPin className="w-4 h-4 ml-2 text-white" />
              <div className='flex items-center gap-2'>
                <h2 className="text-sm font-bold text-white">Location Details</h2>
                 <span className="text-white">•</span>
                <p className="text-sm text-white mt-1">Where is your temple located</p>
              </div>
            </div>
          </div>

          <div className="p-8">
            <div className="space-y-6">
              <InputField
                label="Full Address"
                name="fullAddress"
                placeholder="Enter complete address"
                 value={formData.fullAddress}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.fullAddress}
                touched={touched.fullAddress}
                required
              />

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <InputField
                  label="City"
                  name="city"
                  placeholder="Enter city"
                  value={formData.city}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.city}
                touched={touched.city}
                  required
                />
                <InputField
                  label="State"
                  name="state"
                  placeholder="Enter state"
                   value={formData.state}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.state}
                touched={touched.state}
                  required
                />
                <InputField
                  label="Pincode"
                  name="pincode"
                  placeholder="6-digit pincode"
                   value={formData.pincode}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.pincode}
                touched={touched.pincode}
                  maxLength="6"
                  required
                />
              </div>

              <InputField
  label="Google Map Location (URL or Coordinates)"
  name="googleMapLink "
  value={formData.googleMapLink }
  onChange={handleInputChange}
  onBlur={handleBlur}
  error={errors.googleMapLink }
  touched={touched.googleMapLink }
  placeholder="https://maps.google.com/... or lat,lng"
/>

            </div>
          </div>
        </div>

        {/* Temple Information Section */}
        <div className="bg-white rounded-2xl  mb-8 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-600 via-red-500 to-orange-600 px-1 py-1 border-b border-orange-200">
            <div className="flex items-center gap-3">
              <Info className="w-4 h-4 ml-2 text-white" />
              <div className='flex items-center gap-2'>
                <h2 className="text-sm font-bold text-white">Temple Information</h2>
                 <span className="text-white">•</span>
                <p className="text-sm text-white mt-1">Details about temple services and timings</p>
              </div>
            </div>
          </div>

          <div className="p-8 space-y-6">
            <InputField
              label="Temple Description"
              name="description"
              placeholder="Describe your temple's history, significance, and features... (minimum 50 characters)"
               value={formData.description}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.description}
                touched={touched.description}
              rows="4"
              required
            />
            <InputField
              label="Darshan Timings"
              name="darshanTimings"
              placeholder="e.g., Morning: 6:00 AM - 12:00 PM, Evening: 5:00 PM - 9:00 PM"
              rows="2"
               value={formData.darshanTimings}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.darshanTimings}
                touched={touched.darshanTimings}
              required
            />
            <InputField
              label="Special Sevas / Pujas Offered"
              name="specialSevas"
              placeholder="List special sevas and pujas available at your temple..."
              rows="3"
               value={formData.specialSevas}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.specialSevas}
                touched={touched.specialSevas}
              required
            />
            <InputField
              label="Temple Rules or Instructions"
              name="templeRules"
               value={formData.templeRules}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={errors.templeRules}
                touched={touched.templeRules}
              placeholder="Enter temple rules and guidelines for visitors..."
              rows="3"
            />
              

 <label
    htmlFor="eventsCalendar"
    className="text-sm font-semibold text-gray-700"
  >
   Annual Pooja & Festival Calendar (PDF / JPG / PNG — Max 2 files)

    <span className="text-red-500"> *</span>
  </label>

  <input
    type="file"
    id="eventsCalendar"
    name="eventsCalendar"
    accept="image/jpeg,image/png,application/pdf"
    multiple
    onChange={handleFileChange}
    className="block w-full text-sm text-gray-700
               file:mr-4 file:py-2 file:px-4
               file:rounded-lg file:border-0
               file:text-sm file:font-semibold
               file:bg-orange-100 file:text-orange-700
               hover:file:bg-orange-200"
  />

  {errors.eventsCalendar && (
    <p className="text-red-500 text-xs">
      {errors.eventsCalendar}
    </p>
  )}
  {formData.eventsCalendar?.length > 0 && (
  <div className="mt-2 space-y-1">
    {formData.eventsCalendar.map((file, index) => (
      <div
        key={index}
        className="flex items-center justify-between bg-orange-50 px-3 py-2 rounded-lg"
      >
        <span className="text-sm text-gray-700 truncate">
          {file.name}
        </span>

        <button
          type="button"
          onClick={() => removeFile(index)}
          className="text-red-500 text-sm hover:underline"
        >
          Cancel
        </button>
      </div>
    ))}
  </div>
)}


          </div>
        </div>

        {/* Social Media Links Section */}
        <div className="bg-white rounded-2xl  mb-8 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-600 via-red-500 to-orange-600 px-1 py-1 border-b border-orange-200">
            <div className="flex items-center gap-3">
              <Share2 className="w-4 h-4 ml-2 text-white" />
              <div className='flex items-center gap-2'>
                <h2 className="text-sm font-bold text-white">Social Media Links</h2>
                 <span className="text-white">•</span>
                <p className="text-sm text-white mt-1">Connect your temple's social media presence</p>
              </div>
            </div>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <InputField
  label="Instagram Profile"
  name="instagramLink"
  value={formData.instagramLink}
  onChange={handleInputChange}
  onBlur={handleBlur}
  error={errors.instagramLink}
  touched={touched.instagramLink}
  placeholder="https://instagram.com/yourtemple"
/>
              <InputField
                label="Facebook Page"
                name="whatsappLink "
                value={formData.whatsappLink }
  onChange={handleInputChange}
  onBlur={handleBlur}
  error={errors.whatsappLink }
  touched={touched.whatsappLink }
                placeholder="https://facebook.com/yourtemple"
              />
              <InputField
                label="YouTube Channel"
                name="youtubeLink"
                value={formData.youtubeLink}
  onChange={handleInputChange}
  onBlur={handleBlur}
  error={errors.youtubeLink}
  touched={touched.youtubeLink}
                placeholder="https://youtube.com/@yourtemple"
              />
            </div>
          </div>
        </div>

        {/* Media Upload Section */}
        <div className="bg-white rounded-2xl mb-8 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-600 via-red-500 to-orange-600 px-3 py-1 border-1 border-orange-200">
            <div className="flex items-center gap-3">
              <ImageIcon className="w-4 h-4 ml-2 text-white" />
              <div className='flex items-center gap-2'>
                <h2 className="text-sm font-bold text-white">Media Upload</h2>
                 <span className="text-white">•</span>
                <p className="text-sm text-white mt-1">Upload temple images (JPG/PNG only, max 5MB each)</p>
              </div>
            </div>
          </div>

          <div className="p-8 space-y-8">
            {/* Temple Profile Image */}
            <div>
              <label className="block text-sm font-semibold text-gray-800 mb-3">
                Temple Profile Image <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="file"
                  id="  profileImage"
                  accept="image/jpeg,image/png"
                  onChange={handleprofileImageUpload}
                  className="hidden"
                />
                
                <label
                  htmlFor="  profileImage"
                  className={`flex flex-col items-center justify-center w-full h-64 border-2 border-dashed rounded-2xl cursor-pointer transition-all ${
                    errors.  profileImage && touched.  profileImage
                      ? 'border-red-500 bg-red-50'
                      : 'border-orange-300 bg-orange-50 hover:bg-orange-100'
                  }`}
                >
                  {profilePreview ? (
                    <div className="relative w-full h-full p-4">
                      <img
                        src={profilePreview}
                        alt="Profile preview"
                        className="w-full h-full object-contain rounded-xl"
                      />

                      <div className="absolute top-6 right-6 bg-white rounded-full p-2 ">
                        <Upload className="w-5 h-5 text-orange-600" />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex items-center justify-center w-16 h-16 mb-4 bg-white rounded-full">
                        <Upload className="w-8 h-8 text-orange-600" />
                      </div>
                      <p className="text-orange-700 font-semibold mb-2">
                        Click to upload or drag and drop
                      </p>
                      <p className="text-gray-500 text-sm">JPG or PNG (max 5MB)</p>
                    </>
                  )}
                </label>
              </div>
              {errors.  profileImage && (
                <div className="flex items-center gap-1 mt-2 text-red-600 text-sm">
                  <AlertCircle className="w-4 h-4" />
                  <span>{errors.  profileImage}</span>
                </div>
              )}
            </div>

            {/* Temple Gallery Images */}
            <div>
              <label className="block text-sm font-semibold text-gray-800 mb-3">
                Temple Gallery Images (Optional, max 10 images)
              </label>
              <div className="relative">
                <input
                  type="file"
                  id="galleryImages"
                  accept="image/jpeg,image/png"
                  multiple
                  onChange={handlegalleryImagesUpload}
                  className="hidden"
                />
                <label
                  htmlFor="galleryImages"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-dashed border-orange-300 rounded-2xl cursor-pointer bg-orange-50 hover:bg-orange-100 transition-all"
                >
                  {galleryPreviews.length > 0 ? (
                    <div className="grid grid-cols-3 md:grid-cols-5 gap-3 p-4 w-full h-full overflow-y-auto">
                      {galleryPreviews.map((preview, index) => (
                        <div key={index} className="relative aspect-square">
                          <img
                            src={preview}
                            alt={`Gallery ${index + 1}`}
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                      ))}
                      <div className="flex items-center justify-center aspect-square border-2 border-dashed border-orange-300 rounded-lg">
                        <Upload className="w-6 h-6 text-orange-600" />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex items-center justify-center w-16 h-16 mb-4 bg-white rounded-full ">
                        <Upload className="w-8 h-8 text-orange-600" />
                      </div>
                      <p className="text-orange-700 font-semibold mb-2">
                        Click to upload multiple images
                      </p>
                      <p className="text-gray-500 text-sm">JPG or PNG (max 5MB each, up to 10 images)</p>
                    </>
                  )}
                </label>
              </div>
              {errors.galleryImages && (
                <div className="flex items-center gap-1 mt-2 text-orange-600 text-sm">
                  <AlertCircle className="w-4 h-4" />
                  <span>{errors.galleryImages}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-end">
         
          <button
            onClick={handleCreateProfile}
            className=" mb-4 px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-xl hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Create Temple Profile
          </button>
        </div>
      </div>
   </div>
    </div>
  );
};

export default TempleRegistration;





